import { LOCALES } from 'i18n/locales';

export const viewObservationPageIntl = {
    [LOCALES.ENGLISH]: {
        'viewObservationPage.page.title': 'Observation details',
        'viewObservationPage.page.dateCollected': 'Date collected',
        'viewObservationPage.page.dateModified': 'Date last updated',
        'viewObservationPage.mapPreview.title': 'Location',
        'viewObservationPage.displayTitle': 'Title',
        'viewObservationPage.observationCategory': 'Category',
        'viewObservationPage.description': 'Description',
        'viewObservationPage.coordinates': 'Coordinates: ',
        'viewObservationPage.edit': 'Edit observation'
    },
    [LOCALES.WELSH]: {
        'viewObservationPage.page.title': 'Manylion arsylwad',
        'viewObservationPage.page.dateCollected': 'Dyddiad casglu',
        'viewObservationPage.page.dateModified': 'Dyddiad diweddaru diwethaf',
        'viewObservationPage.mapPreview.title': 'Lleoliad',
        'viewObservationPage.displayTitle': 'Teitl',
        'viewObservationPage.observationCategory': 'Categori',
        'viewObservationPage.description': 'Disgrifiad',
        'viewObservationPage.coordinates': 'Cyfesurynnau: ',
        'viewObservationPage.edit': 'Golygu arsylwad'
    }
};
